export default "__VITE_ASSET__Cm_QMX9s__"